import i18n from "i18next";

// Locale for dates and times shown in the interface: the interface language's
// conventions (24-hour clock in Portuguese, Spanish, French, Chinese,
// Japanese…), refined by a regional variant of that language the browser
// lists (en-GB, pt-PT), so English readers keep their own clock.
export const uiDateLocale = (
  language = i18n.resolvedLanguage || i18n.language || "en",
): string => {
  const base = language.split("-")[0]?.toLowerCase();
  const browser =
    typeof navigator === "undefined"
      ? []
      : (navigator.languages ?? [navigator.language]);
  return (
    browser.find((tag) => tag?.split("-")[0]?.toLowerCase() === base) ??
    language
  );
};
